
import { ServiceWorkerUtils } from '@ajin/utils/service-worker.utils';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { ApiConfig } from '@ajin/config/api.config';
import { environment } from '@projects/worker/environments/environment';


ApiConfig.setUrl(environment.apiUrls.ajin);

bootstrapApplication(AppComponent, appConfig)
    .catch(err => console.error(err));


ServiceWorkerUtils.unregisterIOS17();

